import * as types from "../types/localeTypes";

export const setENG = (en) => {
  return {
    type: types.ENG,
    en,
  };
};

export const setPTR = (pt) => {
  return {
    type: types.PTR,
    pt,
  };
};

export function setLocaleENG(local) {
  return (dispatch) => {
    dispatch(setENG(local));
  };
}

export function setLocalePTR(local) {
  return (dispatch) => {
    dispatch(setPTR(local));
  };
}
